import { Component, TemplateRef } from '@angular/core';
import { ExternalmenuComponent } from '../../../shared/externalmenu/externalmenu.component';
import { CommonModule } from '@angular/common';
import { SidebarService } from '../../../core/services/sidebar.service';
import { ApiService } from '../../../core/services/api.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-insightsmasterv2',
  imports: [ExternalmenuComponent, CommonModule, FormsModule, ReactiveFormsModule],
  standalone: true,
  providers: [NgbActiveModal],
  templateUrl: './insightsmaster.html',
  styleUrl: './insightsmaster.scss'
})
export class Insightsmasterv2 {
  isloading: boolean = false;;
  headingType: any = "";
  isSidebarCollapsed: any;
  isLoading: any;
  widgetForm!: FormGroup;
  status : any = 'Y';
  btnType: any = 0;
  btnStatusType: any = 'Y';
  statusShow : boolean = false;
  filterButtonsList = [
    { id: 0, label: 'All' },
    { id: 1, label: 'Widgets' },
    { id: 2, label: 'Reports' }
  ];
  activeInActiveBtns = [
    { id: 'Y', label: 'Active' },
    { id: 'N', label: 'In-Ative' },
  ];
  constructor(private sidebarService: SidebarService, private AOapi: ApiService, private ngbmodal: NgbModal, public ngbmodalActive: NgbActiveModal, private fb: FormBuilder,) {
    this.setHeaderData();
    this.getinsightsmasterlist();
  }

  setHeaderData() {
    const HeaderData = {
      title: 'Axel Master List',
    };
    this.AOapi.SetHeaderData({ obj: HeaderData });
  }
  ngOnInit(): void {
    this.sidebarService.isCollapsed$.subscribe((collapsed: boolean) => {
      //alert('Hello this is dashboard..!')
      this.isSidebarCollapsed = collapsed;
    });
    this.widgetForm = this.fb.group({
      uniqueid: [''],
      module: [''],
      title: [''],
      desc: [''],
      schema: [''],
      api: [''],
      sequence: [''],
      xpertmodel: [''],
      type: [''],
      notes: ['']
    });
    const modalEl = document.getElementById('addModal');
    modalEl?.addEventListener('show.bs.modal', () => {
      // this.widgetForm.reset();
      this.editId = null;
    });

  }

  select(id: any) {
    this.btnType = id;
    if (this.btnType == 0) {
      this.insightsdata = this.insightsdataCopy;
    }
    else if (this.btnType == 1) {
      this.insightsdata = this.insightsdataCopy.filter((e: any) => e.AXML_TYPE == this.btnType)
    }
    else {
      this.insightsdata = this.insightsdataCopy.filter((e: any) => e.AXML_TYPE == this.btnType)
    }
  }
  selectStatusBtn(id: any) {
    this.btnStatusType = id;
    if (this.btnStatusType == "Y") {
      this.insightsdata = this.insightsdataCopy.filter((e: any) => e.AXML_STATUS == this.btnStatusType)
    }
    else {
      this.insightsdata = this.insightsdataCopy.filter((e: any) => e.AXML_STATUS == this.btnStatusType)
    }
  }


  insightsdata: any = [];
  insightsdataCopy: any = [];
  searchText: any;
  getinsightsmasterlist() {
    this.isloading = true;
    let body = {
      "id": 0,
      "exp": ""
    }
    this.AOapi.postmethodInsights('insights/GetAxelMasterList', body).subscribe((res: any) => {
      console.log(res);
      if (res.status == 200) {
        this.insightsdata = res.response.filter((e: any)=>e.AXML_STATUS == this.btnStatusType);
        this.insightsdataCopy =  res.response;
        this.isloading = false;
      }
      else {
        this.insightsdata = [];
        this.isloading = false;;
      }
    });
  }

  applySearch() {
  }

  editId: any;
  editclick(data: any) {
    this.statusShow = true;
    this.headingType = data.AXML_TYPE == 1 ? 'Edit Widget' : 'Edit Report';
    this.editId = data.AXML_ID;
    this.status = data.AXML_STATUS;
    this.widgetForm.patchValue({
      uniqueid: data.AXML_UNIQUE,
      module: data.AXML_MODULE,
      title: data.AXML_TITLE,
      desc: data.AXML_DESC,
      schema: data.AXML_SCHEMA_INFO,
      api: data.AXML_API_INFO,
      sequence: data.AXML_SEQUENCE,
      xpertmodel: data.AXML_XPERT_MODELID,
      type: data.AXML_TYPE,
      notes: data.AXML_NOTES
    });
  }

  onSave() {
    this.isloading = true;
    const form = this.widgetForm.value;
    let body = {
      id: this.editId || null,
      unique: form.uniqueid,
      module: form.module,
      title: form.title,
      desc: form.desc,
      schema: form.schema,
      apiinfo: form.api,
      sequence: form.sequence,
      xpertmodel: form.xpertmodel || '',
      uid: 1,
      status: this.status,
      type: form.type,
      notes: form.notes
    }
    console.log(body)
    this.AOapi.postmethodInsights('insights/AxelMasterlistAction', body).subscribe(
      (data: any) => {
        this.isLoading = false;
        if (data && data.status === 200) {
          // let msg = (this.editId != '' && this.editId != undefined) ? "Widget Updated succesfully!" : "Widget Added succesfully!";
          let msg = data.response.message;
          alert(msg);
          document.getElementById('closeModalBtn')?.click();
          this.getinsightsmasterlist();
          this.widgetForm.reset();
          this.isloading = false;
        } else if (data && data.status === 401) {
          alert("Already exists!");
          this.isloading = false;

        } else {
          this.isloading = false;
        }
      },
      (err: any) => {
        this.isLoading = false;
      }
    );
  }

  onCancel() {
    document.getElementById('closeModalBtn')?.click();
  }

  addNewWidget() {
    this.statusShow = false;
    this.widgetForm.reset()
    // this.widgetForm.controls['type'].setValue(1);
    this.headingType = this.btnType == 0 ? this.widgetForm.controls['type'].setValue(0) : this.btnType == 1 ? this.widgetForm.controls['type'].setValue(1) : this.widgetForm.controls['type'].setValue(2);
    this.headingType = this.btnType == 0 ? 'Add New Item' : this.btnType == 1 ? 'Add New Widget' : 'Add New Report';
  }
  statusChange(e: any){
    this.status = e.target.checked == true ? 'Y' : 'N';
  }
}
